import { CgMathEqual } from "react-icons/cg";
import { MdOutlineDashboard } from "react-icons/md";

// Dashboard
const dashboardLinks = [{ name: "Dashboard", slugurl: "dashboard" }];

const dashboardMenu = [
  {
    key: "1",
    icon: <MdOutlineDashboard size={24} />,
    label: "Dashboard",
    path: "dashboard",
    style: {
      backgroundColor: "#cb1b5b",
      color: "#fff",
    },
  },
];

// HealthSynergy
const healthSynergyLinks = [
  { name: "HealthSy Partnered Doctor..", slugurl: "doctor-registration" },
  { name: "HealthSy Partnered Pharma..", slugurl: "pharmacy-registration" },
  { name: "HealthSy Partnered Home H..", slugurl: "healthcare-registration" },
  { name: "InstaDoc", slugurl: "insta-doc" },
  { name: "Others", slugurl: "other-registration" },
  { name: "Book a Demo", slugurl: "doctor-demo" },
];

const healthSynergyMenu = [
  {
    key: "s1",
    label: "HealthSynergy",
    icon: <CgMathEqual size={20} />,
    children: healthSynergyLinks.map((data, inx) => ({
      key: `101${inx}`,
      label: data.name,
      path: data.slugurl,
    })),
  },
];

// Masters
const mastersLinks = [
  { name: "Doctors", slugurl: "master-primary-specialisation" },
  { name: "Home Healthcare Services", slugurl: "master-health-care" },
  { name: "Partnered Pharmacies", slugurl: "master-partnered-pharmacy" },
  { name: "Others", slugurl: "master-others" },
  { name: "Common", slugurl: "master-gender" },
];

const mastersMenu = [
  {
    key: "sub3",
    label: "Masters",
    icon: <CgMathEqual size={20} />,
    children: mastersLinks.map((data, inx) => ({
      key: `301${inx}`,
      label: data.name,
      path: data.slugurl,
    })),
  },
];

// Popup Data
const popupDataLinks = [
  { name: "Post a Comment", slugurl: "comment" },
  { name: "News letter Subscription", slugurl: "blog-subscribe" },
];

const popupDataMenu = [
  {
    key: "s2",
    label: "Popup Data",
    icon: <CgMathEqual size={20} />,
    children: popupDataLinks.map((data, inx) => ({
      key: `41${inx}`,
      label: data.name,
      path: data.slugurl,
    })),
  },
];

// Blogs
const blogsLinks = [
  { name: "Blogs", slugurl: "healtharticle" },
  { name: "Blog Search Keyword", slugurl: "blog-search-keyword" },
  { name: "Blog Banner Image", slugurl: "blog-banner-image" },
];

const blogsMenu = [
  {
    key: "s3",
    label: "Blogs",
    icon: <CgMathEqual size={20} />,
    children: blogsLinks.map((data, inx) => ({
      key: `401${inx}`,
      label: data.name,
      path: data.slugurl,
    })),
  },
];

// Careers
const careersLinks = [{ name: "Careers", slugurl: "careers" }];

const careersMenu = [
  {
    key: "2",
    icon: <CgMathEqual size={20} />,
    label: "Careers",
    path: "careers",
  },
];

// HealthSy Services
const healthSyServicesLinks = [
  {
    name: "Order Medicine",
    children: [
      {
        name: "Medicine List",
        slugurl: "healthsy-services/order-medicines/medicine-details",
      },
      {
        name: "Masters",
        slugurl: "healthsy-services/order-medicines/masters/manufacturer",
      },
      { name: "Assets", slugurl: "healthsy-services/order-medicines/assets" },
    ],
  },
];

const healthSyServicesMenu = [
  {
    key: "s4",
    label: "HealthSy Services",
    icon: <CgMathEqual size={20} />,
    children: healthSyServicesLinks.map((data, inx) => ({
      key: `sn${inx + 1}`,
      label: data.name,
      children: data.children?.map((child, childInx) => ({
        key: `50${inx + 1}${childInx + 1}`,
        label: child.name,
        path: child.slugurl,
      })),
    })),
  },
];

// Doctors
const doctorsLinks = [
  { name: "Partnered Doctor..", slugurl: "partnered-doctor-online" },
  { name: "Specialisation Listing Meta", slugurl: "add-new-doctors" },
  { name: "Doctor Specialisation", slugurl: "online-doctor-specialisation" },
  { name: "City & Localities List", slugurl: "doctors-location" },
  { name: "Clinic Profile", slugurl: "doctor-clinic-profile" },
  { name: "Clinic Services", slugurl: "doctor-clinic-service" },
  { name: "Common Heads", slugurl: "doctors-gender" },
  { name: "Report a Error", slugurl: "doctors-report" },
];

const doctorsMenu = [
  {
    key: "s5",
    label: "Doctors",
    icon: <CgMathEqual size={20} />,
    children: doctorsLinks.map((data, inx) => ({
      key: `60${inx + 1}`,
      label: data.name,
      path: data.slugurl,
    })),
  },
];

// Home Healthcare
const homeHealthcareLinks = [
  {
    name: "Add New Service Provider",
    slugurl: "home-healthcare-service-provider",
  },
  { name: "HHSP Specialisations", slugurl: "home-healthcare-hhsp" },
];

const homeHealthcareMenu = [
  {
    key: "s6",
    label: "Home Healthcare Se..",
    icon: <CgMathEqual size={20} />,
    children: homeHealthcareLinks.map((data, inx) => ({
      key: `s6${inx + 1}`,
      label: data.name,
      path: data.slugurl,
    })),
  },
];

// Partnered Pharmacies
const partneredPharmaciesLinks = [
  { name: "Add New Retail Pharmacies", slugurl: "add-new-retail-pharmacy" },
];

const partneredPharmaciesMenu = [
  {
    key: "s7",
    label: "Partnered Pharmacies",
    icon: <CgMathEqual size={20} />,
    children: partneredPharmaciesLinks.map((data, inx) => ({
      key: `s7${inx + 1}`,
      label: data.name,
      path: data.slugurl,
    })),
  },
];

// Clinic / Hospital
const clinicHospitalLinks = [
  { name: "Add New Clinic / Hospital", slugurl: "add-new-clinic" },
];

const clinicHospitalMenu = [
  {
    key: "s8",
    label: "Clinic / Hospital",
    icon: <CgMathEqual size={20} />,
    children: clinicHospitalLinks.map((data, inx) => ({
      key: `s8${inx + 1}`,
      label: data.name,
      path: data.slugurl,
    })),
  },
];

// Settings
const settingsLinks = [
  { name: "Social Media Links", slugurl: "settings-social-media-form" },
  { name: "Banner Images", slugurl: "add-banner-images" },
  { name: "Play Store / App Store Links", slugurl: "store-links" },
  { name: "Business Settings", slugurl: "business-settings" },
  { name: "Meta Tags", slugurl: "meta-tags" },
  { name: "Email Settings", slugurl: "email-setting" },
  { name: "Insiders", slugurl: "insiders" },
  { name: "Company Reels", slugurl: "company-reels" },
];

const settingsMenu = [
  {
    key: "s9",
    label: "Settings",
    icon: <CgMathEqual size={20} />,
    children: settingsLinks.map((data, inx) => ({
      key: `70${inx + 1}`,
      label: data.name,
      path: data.slugurl,
    })),
  },
];

// Sitemap
const sitemapLinks = [
  { name: "Sitemap Analysis", slugurl: "sitemap/parent-sitemap" },
  { name: "Other Codes / Pixel", slugurl: "site-map-setting" },
  { name: "Common Masters", slugurl: "sitemap-category" },
];

const sitemapMenu = [
  {
    key: "s10",
    label: "Sitemap",
    icon: <CgMathEqual size={20} />,
    children: sitemapLinks.map((data, inx) => ({
      key: `s10${inx + 1}`,
      label: data.name,
      path: data.slugurl,
    })),
  },
];

// Email Brochures
const emailBrochuresLinks = [
  { name: "Doctor Registration", slugurl: "doctor-registration-brochures" },
  { name: "Doctor Demo", slugurl: "doctor-demo-registration-brochures" },
  { name: "Pharmacy Registration", slugurl: "pharmacy-registration-brochures" },
  {
    name: "Healthcare Registration",
    slugurl: "healthcare-registration-brochures",
  },
  { name: "Other Registartion", slugurl: "others-registration-brochures" },
];

const emailBrochuresMenu = [
  {
    key: "s11",
    label: "Email Brochures",
    icon: <CgMathEqual size={20} />,
    children: emailBrochuresLinks.map((data, inx) => ({
      key: `s11${inx + 1}`,
      label: data.name,
      path: data.slugurl,
    })),
  },
];

// CTA Banner
const CTABannerLinks = [
  { name: "Retail Pharmacies", slugurl: "cta-banner/retail-pharmacies" },
  { name: "Doctors", slugurl: "cta-banner/doctors" },
  {
    name: "Home Healthcare Service Providers",
    slugurl: "cta-banner/home-healthcare-service-providers",
  },
];

const CTABannerMenu = [
  {
    key: "s13",
    label: "CTA Banner",
    icon: <CgMathEqual size={20} />,
    children: CTABannerLinks.map((data, inx) => ({
      key: `s13${inx + 1}`,
      label: data.name,
      path: data.slugurl,
    })),
  },
];

// CTA Form
const CTAFormLinks = [
  { name: "Retail Pharmacies", slugurl: "cta-form/retail-pharmacies" },
  { name: "Doctors", slugurl: "cta-form/doctors" },
  {
    name: "Home Healthcare Service Providers",
    slugurl: "cta-form/home-healthcare-service-providers",
  },
];

const CTAFormMenu = [
  {
    key: "s14",
    label: "CTA Form",
    icon: <CgMathEqual size={20} />,
    children: CTAFormLinks.map((data, inx) => ({
      key: `s14${inx + 1}`,
      label: data.name,
      path: data.slugurl,
    })),
  },
];

// Contact Form
const contactFormLinks = [{ name: "Contact Form", slugurl: "contact-us" }];

const contactFormMenu = [
  {
    key: "3",
    icon: <CgMathEqual size={20} />,
    label: "Contact Form",
    path: "contact-us",
  },
];

// Legal Pages
const LegalPageAppDownloadLinks = [
  { name: "Website", slugurl: "website" },
  { name: "Doctor", slugurl: "doctor-app" },
  { name: "Pharmacy", slugurl: "pharmacy-app" },
  { name: "HHSP", slugurl: "hhsp-app" },
  { name: "InstaDoc", slugurl: "instadoc" },
  { name: "Collaborate with us", slugurl: "collaborate-with-us" },
];

const legalPagesMenu = [
  {
    key: "s15",
    label: "Legal Pages - web",
    icon: <CgMathEqual size={20} />,
    children: LegalPageAppDownloadLinks.map((data, inx) => ({
      key: `s15${inx}`,
      label: data.name,
      path: `app-download-link/${data.slugurl}`,
    })),
  },
];

// Web Bookings
const WebBookingsLinks = [
  {
    name: "Web Bookings, Consultations & Appointments",
    slugurl: "web-bookings/home-healthcare-bookings",
  },
];

const WebBookingsMenu = [
  {
    key: "4",
    icon: <CgMathEqual size={20} />,
    label: "Web Bookings, Consultations & Appointments",
    path: "web-bookings/home-healthcare-bookings",
  },
];

// Ad Landing Forms
const adLandingFormsLinks = [
  { name: "Ad Landing Forms", slugurl: "ad-landing-forms/partnered-doctors" },
];

const adLandingFormsMenu = [
  {
    key: "5",
    icon: <CgMathEqual size={20} />,
    label: "Ad Landing Forms",
    path: "ad-landing-forms/partnered-doctors",
  },
];

// Ad Landing Meta Tags
const adLandingMetaTagsLinks = [
  { name: "Ad Landing Meta Tags", slugurl: "ad-landing-meta-tags" },
];

const adLandingMetaTagsMenu = [
  {
    key: "6",
    icon: <CgMathEqual size={20} />,
    label: "Ad Landing Meta Tags",
    path: "ad-landing-meta-tags",
  },
];

// Insta Doc QR Code
const InstaDocQRCodeLinks = [
  { name: "Insta Doc QR Code", slugurl: "insta-doc-qr-code" },
];

const InstaDocQRCodeMenu = [
  {
    key: "7",
    icon: <CgMathEqual size={20} />,
    label: "Insta Doc QR Code",
    path: "insta-doc-qr-code",
  },
];

// Counter
const counterLinks = [
  { name: "Home Page", slugurl: "counter-home" },
  { name: "Ad Landing User General", slugurl: "ad-user-counter" },
  { name: "Sustainability Policy", slugurl: "sustainability-policy-counter" },
];

const counterMenu = [
  {
    key: "s16",
    label: "Counter",
    icon: <CgMathEqual size={20} />,
    children: counterLinks.map((data, inx) => ({
      key: `s16${inx + 1}`,
      label: data.name,
      path: data.slugurl,
    })),
  },
];

// Sustainability Policy
const SustainabilityPolicyLinks = [
  { name: "Sustainability Policy", slugurl: "sustainability-policy" },
];

const SustainabilityPolicyMenu = [
  {
    key: "8",
    icon: <CgMathEqual size={20} />,
    label: "Sustainability Policy",
    path: "sustainability-policy",
  },
];

// FRP
const FRPLinks = [{ name: "FRP", slugurl: "frp-states" }];

const FRPMenu = [
  {
    key: "9",
    icon: <CgMathEqual size={20} />,
    label: "FRP",
    path: "frp-states",
  },
];

// Franchise Programme
const FranchiseProgrammeLinks = [
  { name: "Contact Us", slugurl: "franchise-programme/contact-us" },
  {
    name: "Interest Submitted List",
    slugurl: "franchise-programme/interest-submitted-list",
  },
  { name: "Store Locations", slugurl: "franchise-programme/store-locations" },
  {
    name: "City / Town Masters",
    slugurl: "franchise-programme/city-town-masters",
  },
  { name: "FAQs", slugurl: "franchise-programme/faq-masters" },
];

const FranchiseProgrammeMenu = [
  {
    key: "11",
    label: "Franchise Programme",
    icon: <CgMathEqual size={20} />,
    children: FranchiseProgrammeLinks.map((data, inx) => ({
      key: `a-1${inx + 1}`,
      label: data.name,
      path: data.slugurl,
    })),
  },
];

// Franchise Customers
const FranchiseCustomersLinks = [
  {
    name: "HealthSy Pharmacy Cities",
    slugurl: "pharmacy-customers/pharmacy-cities",
  },
  { name: "Store Locations", slugurl: "pharmacy-customers/store-location" },
  { name: "Testimonials", slugurl: "pharmacy-customers/store-locations" },
  { name: "Blogs & Guides", slugurl: "pharmacy-customers/blogs-guides" },
  { name: "State, City Masters", slugurl: "pharmacy-customers/state-city" },
  { name: "Store Interior", slugurl: "pharmacy-customers/store-interior" },
];

// const FranchiseCustomersMenu = [
//   {
//     key: "12",
//     label: "Franchise Customers",
//     icon: <CgMathEqual size={20} />,
//     children: FranchiseCustomersLinks.map((data, inx) => ({
//       key: `b-1${inx + 1}`,
//       label: data.name,
//       path: data.slugurl,
//     })),
//   },
// ];

// RP QR Ratings

const RPQRRatingsLinks = [
  {
    name: "Pharmacies Partner ID",
    slugurl: "rp-qr-ratings/pharmacies-partner-id",
  },
  { name: "Rp-Qr-Rating Form", slugurl: "rp-qr-ratings/pharmacy-rating" },
];

const RPQRRatingsMenu = [
  {
    key: "s17",
    label: "RP QR Ratings",
    icon: <CgMathEqual size={20} />,
    children: RPQRRatingsLinks.map((data, inx) => ({
      key: `s17${inx + 1}`,
      label: data.name,
      path: data.slugurl,
    })),
  },
];

// Delivery App Training Centre
const DeliveryAppTrainingCentreLinks = [
  {
    name: "Delivery App Training Centre",
    slugurl: "delivery-app-training-centre",
  },
];

const DeliveryAppTrainingCentreMenu = [
  {
    key: "13",
    icon: <CgMathEqual size={20} />,
    label: "Delivery App Training Centre",
    path: "delivery-app-training-centre",
  },
];

// FINAL MENU
export const sideMenuItems = [
  ...dashboardMenu,
  ...healthSynergyMenu,
  ...mastersMenu,
  ...popupDataMenu,
  ...blogsMenu,
  ...careersMenu,
  ...healthSyServicesMenu,
  ...doctorsMenu,
  ...homeHealthcareMenu,
  ...partneredPharmaciesMenu,
  ...clinicHospitalMenu,
  ...settingsMenu,
  ...sitemapMenu,
  ...emailBrochuresMenu,
  ...CTABannerMenu,
  ...CTAFormMenu,
  ...contactFormMenu,
  ...legalPagesMenu,
  ...WebBookingsMenu,
  ...adLandingFormsMenu,
  ...adLandingMetaTagsMenu,
  ...InstaDocQRCodeMenu,
  ...counterMenu,
  ...SustainabilityPolicyMenu,
  ...FRPMenu,
  ...FranchiseProgrammeMenu,
  // ...FranchiseCustomersMenu,
  ...RPQRRatingsMenu,
  ...DeliveryAppTrainingCentreMenu,
];
